(function () {
  if (window.__mcPdp) return; window.__mcPdp = true;
  function carousels(scope) {
    scope.querySelectorAll('[data-mc-carousel]').forEach(function (c) {
      if (c.__mc) return; c.__mc = true;
      var t = c.querySelector('[data-track]'); if (!t) return;
      function step() { var f = t.children[0]; if (!f) return t.clientWidth; var g = parseFloat(getComputedStyle(t).columnGap || getComputedStyle(t).gap) || 0; return f.getBoundingClientRect().width + g; }
      var p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
      /* is-static = every card fits, nothing to scroll (CSS can then center the track and hide the arrows) */
      function fit() { c.classList.toggle('is-static', t.scrollWidth <= t.clientWidth + 1); }
      fit(); window.addEventListener('resize', fit); if ('ResizeObserver' in window) new ResizeObserver(fit).observe(t);
    });
    scope.querySelectorAll('[data-vplay]').forEach(function (b) {
      if (b.__mc) return; b.__mc = true;
      var card = b.closest('.mc-vcard'), v = card.querySelector('video');
      function set(playing) { card.classList.toggle('is-playing', playing); b.setAttribute('aria-pressed', playing); b.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + b.getAttribute('aria-label').replace(/^(Play|Pause)/, '')); }
      v.addEventListener('play', function () { set(true); });
      v.addEventListener('pause', function () { set(false); });
      v.addEventListener('ended', function () { set(false); });
      b.addEventListener('click', function () {
        if (!v.paused) { v.pause(); return; }
        document.querySelectorAll('.mc-vcard video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
        v.removeAttribute('autoplay'); v.autoplay = false; v.muted = false; v.volume = 1;
        var p = v.play(); if (p && p.catch) p.catch(function () { set(false); });
      });
    });
    scope.querySelectorAll('[data-mc-tabs]').forEach(function (s) {
      if (s.__mc) return; s.__mc = true;
      var tabs = Array.prototype.slice.call(s.querySelectorAll('[role=tab]'));
      function sel(i) { tabs.forEach(function (t, j) { var on = i === j; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on; }); tabs[i].focus(); }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(i); });
        t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') sel((i + 1) % tabs.length); if (e.key === 'ArrowLeft') sel((i - 1 + tabs.length) % tabs.length); });
      });
    });
  }
  function boot() { carousels(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { carousels(e.target); });
})();
